module.exports = __webpack_public_path__ + "img/qizhi_unselected.8b552605.png";